import { useMutation, useQueryClient } from "@tanstack/react-query";

import { LabelData } from "../../../models/LabelData";
import DataSvc from "../../../services/dataSvc";

const useLocationLabels = (locationId: number) => {
  const queryClient = useQueryClient();

  const connectLabelMutation = useMutation((payload: any) => {
    return DataSvc.addLocationLabel(payload.locationId, payload.labelId);
  });

  const connectLabel = async (label: LabelData) => {
    await connectLabelMutation.mutateAsync({
      locationId,
      labelId: label.id
    });

    // Add label to the query data for the location
    queryClient.setQueryData(["location", locationId], (oldData: any) => {
      return {
        ...oldData,
        labels: [...oldData.labels, label]
      };
    });

    // Invalidate the query for the location,
    // causing a background refetch
    queryClient.invalidateQueries({
      queryKey: ["location", locationId]
    });
  };

  const disconnectLabelMutation = useMutation((payload: any) => {
    return DataSvc.deleteLocationLabel(payload.locationId, payload.labelId);
  });

  const disconnectLabel = async (labelId: number) => {
    await disconnectLabelMutation.mutateAsync({
      locationId,
      labelId
    });

    // Remove label from the query data for the location
    queryClient.setQueryData(["location", locationId], (oldData: any) => {
      return {
        ...oldData,
        labels: oldData.labels.filter(
          (label: LabelData) => label.id !== labelId
        )
      };
    });

    // Invalidate the query for the location,
    // causing a background refetch
    queryClient.invalidateQueries({
      queryKey: ["location", locationId]
    });

    // invalidate the locations query so that it will refetch locations
    // this will cause this location to be removed from currently displayed locations
    // if it was being displayed because of this label
    queryClient.invalidateQueries({
      queryKey: ["locations"]
    });
  };

  return {
    connectLabel,
    disconnectLabel
  };
};

export default useLocationLabels;
